import { useContext, createContext } from "react";
import {createContextualCan} from '@casl/react';

export const AppContext = createContext(null);
export const Can = createContextualCan(AppContext.Consumer);
export function useAppContext() {
	return useContext(AppContext);
}